import React from "react";
import { Button } from "react-bootstrap";
import { BiSolidTrash } from "react-icons/bi";

function DeleteIcon({ id, onDelete, size }) {
  return (
    <Button
      variant="outline-danger"
      className="rounded-circle d-flex align-items-center justify-content-center p-2"
      onClick={(e) => {
        e.stopPropagation(); // Prevent click from bubbling up
        onDelete(id); // Call the delete function passed from parent
      }}
      style={{
        borderColor: "rgba(251, 79, 36, 0.2)",
        color: "#FB4F24",
        background: "rgba(251, 79, 36, 0.02)",
      }}
    >
      <BiSolidTrash size={size||14} />
    </Button>
  );
}

export default DeleteIcon;
